export interface AuditLog {
  id: string
  userId: string
  eventType: 'Create' | 'Edit' | 'Sync' | 'Status Change'
  source: 'BO_USER' | 'BANK_API' | 'SYSTEM'
  timestamp: string
  changes: Array<{
    fieldName: string
    oldValue: string | null
    newValue: string | null
  }>
}
export const createAuditLog = (
  logData: Omit<AuditLog, 'id' | 'timestamp'>,
): void => {
  const auditLog: AuditLog = {
    id: `AUDIT${Date.now()}`,
    ...logData,
    timestamp: new Date().toISOString(),
  }
  const existingLogs = getAuditLogs()
  const updatedLogs = [auditLog, ...existingLogs]
  localStorage.setItem('auditLogs', JSON.stringify(updatedLogs))
}
export const getAuditLogs = (): AuditLog[] => {
  const logs = localStorage.getItem('auditLogs')
  return logs ? JSON.parse(logs) : []
}
export const getAuditLogsByUserId = (userId: string): AuditLog[] => {
  const logs = getAuditLogs()
  return logs.filter((log) => log.userId === userId)
}
export const getAuditLogsByEventType = (
  eventType: AuditLog['eventType'],
): AuditLog[] => {
  const logs = getAuditLogs()
  return logs.filter((log) => log.eventType === eventType)
}
